import { create } from 'zustand';

export type AuditHistoryData = {
  selectedIds?: string[];
  questionIds?: number[];
  auditHistoryParams?: {
    auditHistoryTypes?: number[];
    questionCategory?: string;
    ruleReferenceIdentifiers?: {
      ruleReferenceType?: number;
      lenderDatabaseId?: number;
      ruleReferenceValue?: string;
    }[];
  };
  questions?: {
    id?: number;
    text?: string;
  }[];
  auditHistoryPath?: number | string;
};

type AuditHistoryButtonStore = {
  auditHistoryData?: AuditHistoryData;
  setAuditHistoryData: (data: AuditHistoryData) => void;
};

export const useAuditHistoryButtonStore = create<AuditHistoryButtonStore>()(
  (set) => ({
    auditHistoryData: {},
    setAuditHistoryData: (data) => {
      set({ auditHistoryData: data });
    },
  }),
);
